import { useAppClockService, useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { useGetReservationsForLinking } from './useGetReservationsForLinking';

export const useGetDefaultProductConsumeDate = (accountId: string, scopedReservationIds?: string[]) => {
    const appClockService = useAppClockService();
    const now = appClockService.getAppNowUtc().value;
    const reservations = useGetReservationsForLinking(accountId, scopedReservationIds);
    const preventingProductServiceOutsideOfReservationWindowEnabled = useFeatureFlag(
        FeatureFlag.preventingProductServiceOutsideOfReservationWindow
    );

    return (linkedReservationId: string | null | undefined) => {
        if (!preventingProductServiceOutsideOfReservationWindowEnabled || !linkedReservationId) {
            return now;
        }

        const reservation = reservations.find((res) => res.reservationId === linkedReservationId);

        return reservation && reservation.reservationStartUtc > now ? reservation.reservationStartUtc : now;
    };
};
